import React from 'react';
import { useInView } from 'react-intersection-observer';

const AnimateIn = ({
  threshold = 0.15,
  distance = 100,
  transition = 400,
  triggerOnce = true,
  slideUp = false,
  children,
  ...remainingProps
}) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce,
    initialInView: true, // assume visible until proven otherwise — avoids the opacity-0 trap
  });

  const translate = slideUp ? 'translateY' : 'translateX';

  return (
    <div
      ref={ref}
      style={{
        transition: `opacity ${transition}ms, transform ${transition}ms`,
        opacity: inView ? 1 : 0,
        transform: `${translate}(${inView ? 0 : distance}px)`,
      }}
      {...remainingProps}
    >
      {children}
    </div>
  );
};

export default AnimateIn;
